import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Layout } from 'components'
import styles from './DocflowPage.module.scss'
import DocflowTable from './components/DocflowTable/DocflowTable'
import CreateDocModal from './components/CreateDocModal/CreateDocModal'
import DocumentView from './components/DocumentView/DocumentView'
import { getInbox, getOutbox, getHistory } from '../../service/DocflowService'

const TABS = [
  { key: 'inbox',   label: "📥 Входящие документы" },
  { key: 'outbox',  label: "📤 Исходящие документы" },
  { key: 'history', label: "🗂️ История / Архив" },
]

export default function DocflowPage() {
  useInterfaceLanguage();
  const navigate = useNavigate()
  const [activeTab, setActiveTab]         = useState('inbox')
  const [inbox, setInbox]                 = useState(null)
  const [outbox, setOutbox]               = useState(null)
  const [history, setHistory]             = useState(null)
  const [showCreate, setShowCreate]       = useState(false)
  const [selectedDocId, setSelectedDocId] = useState(null)

  const loadInbox   = useCallback(() => getInbox().then(r   => setInbox(r.data)).catch(() => setInbox([])), [])
  const loadOutbox  = useCallback(() => getOutbox().then(r  => setOutbox(r.data)).catch(() => setOutbox([])), [])
  const loadHistory = useCallback(() => getHistory().then(r => setHistory(r.data)).catch(() => setHistory([])), [])

  useEffect(() => { loadInbox() },   [loadInbox])
  useEffect(() => { loadOutbox() },  [loadOutbox])
  useEffect(() => { loadHistory() }, [loadHistory])

  function handleCreated(doc) {
    setShowCreate(false)
    loadOutbox()
    setSelectedDocId(doc.id)
    setActiveTab('outbox')
  }

  function handleDocClose() {
    setSelectedDocId(null)
    // Refresh the active tab
    if (activeTab === 'inbox')   loadInbox()
    if (activeTab === 'outbox')  loadOutbox()
    if (activeTab === 'history') loadHistory()
  }

  const docsForTab = activeTab === 'inbox' ? inbox : activeTab === 'outbox' ? outbox : history

  const inboxUnread = (inbox || []).filter(d => !d.is_read).length

  return (
    <Layout>
    <div className={styles.page}>
      {/* ── Back navigation ── */}
      <button className={styles.backBtn} onClick={() => navigate(-1)}>
        <span className={styles.backArrow}>←</span>
        <span>{tr("Кабинет сотрудника")}</span>
      </button>

      {/* ── Official banner ── */}
      <div className={styles.officialBanner}>
        <div className={styles.bannerIcon}>🏛️</div>
        <div className={styles.bannerText}>
          <div className={styles.orgName}>{tr("ОАО «КЫРГЫЗКОМУР»")}</div>
          <div className={styles.sysName}>{tr("Система электронного документооборота")}</div>
        </div>
      </div>

      {/* ── Header ── */}
      <div className={styles.pageHeader}>
        <div>
          <h1 className={styles.pageTitle}>{tr("Документооборот")}</h1>
          <p className={styles.pageSubtitle}>{tr("Отправляйте, получайте и подписывайте служебные документы")}</p>
        </div>
        <button
          className={styles.createBtn}
          onClick={() => setShowCreate(true)}
        >{tr("📝 Создать новый документ")}</button>
      </div>

      {/* ── Tabs ── */}
      <div className={styles.tabs}>
        {TABS.map(t => (
          <button
            key={t.key}
            className={`${styles.tab} ${activeTab === t.key ? styles.tabActive : ''}`}
            onClick={() => setActiveTab(t.key)}
          >
            {tr(t.label)}
            {tr(t.key === 'inbox' && inboxUnread > 0 && (
              <span className={styles.tabBadge}>{tr(inboxUnread)}</span>
            ))}
          </button>
        ))}
      </div>

      {/* ── Content ── */}
      <div className={styles.tableCard}>
        <DocflowTable
          docs={docsForTab}
          mode={activeTab}
          onSelect={id => setSelectedDocId(id)}
        />
      </div>

      {/* ── Modals ── */}
      {tr(showCreate && (
        <CreateDocModal
          onClose={() => setShowCreate(false)}
          onCreated={handleCreated}
        />
      ))}

      {tr(selectedDocId && (
        <DocumentView
          docId={selectedDocId}
          onClose={handleDocClose}
        />
      ))}
    </div>
    </Layout>
  )
}
